import { Temporal } from '@js-temporal/polyfill';
import { DateParts, TimeParts } from '../../../types';

function toTemporalPlainTime(time: TimeParts): Temporal.PlainTime {
  return Temporal.PlainTime.from(
    {
      hour: time.hours,
      minute: time.minutes,
      second: time.seconds ?? 0,
      millisecond: time.milliseconds ?? 0,
    },
    {
      overflow: 'reject',
    },
  );
}
export const createDateTimeInstant = (timeZone: string) => (dateParts: DateParts) => (
  timeParts: TimeParts,
): Temporal.Instant | undefined => {
  try {
    const plainDate = Temporal.PlainDate.from(
      {
        year: dateParts.year!,
        month: dateParts.month! + 1, // Adjust from 0-based to 1-based month
        day: dateParts.day!,
      },
      {
        overflow: 'reject',
      },
    );
    const zoned = plainDate.toZonedDateTime({
      timeZone,
      plainTime: Temporal.PlainTime.from(toTemporalPlainTime(timeParts)),
    });
    return zoned.toInstant();
  } catch (error) {
    return undefined;
  }
};
